<template>
	<div class="select">
		<layout>
			<a class="input">
				{{value || "..."}}
				<div class="icon" v-html="require('@/assets/icons/sort-down-solid.svg')"/>
			</a>

			<div class="options" v-if="active">
				<a class="option" v-for="option in options" :class="{selected: value === option}" :key="option" v-text="option" @mousedown="select(option)"/>
			</div>
		</layout>

		<input
			readonly
			ref="input"
			:value="this.value"
			@mousedown="toggle"
			@blur="active = false"
			@focus="active = true"
			@keydown.prevent.up="key({up: true})"
			@keydown.prevent.down="key({down: true})"
			@keydown.prevent.enter="active = false"
			@keydown.prevent.esc="active = false"
		/>
	</div>
</template>

<script>
import layout from "./layout/input.vue";

export default {
	components: {layout},
	props: {
		value: {type: String, required: false},
		options: {type: Array, required: true}
	},
	data() {
		return {
			val: this.value,
			active: false
		}
	},
	computed: {
		index: (t) => t.options.indexOf(t.value),
		next: (t) => t.options[t.index + 1] || t.options[0],
		prev: (t) => t.options[t.index - 1] || t.options[t.options.length - 1],
	},
	methods: {
		toggle() {
			this.active = !this.active;
		},
		select(option) {
			this.active = false;
			this.update(option);
		},
		update(option) {
			this.$emit("update", option);
		},
		key({down, up}) {
			if (up) this.update(this.prev);
			if (down) this.update(this.next);
		}
	}
};
</script>

<style lang="scss" scoped>
.select {
	position: relative;
	user-select: none;

	.input {
		display: flex;
		justify-content: space-between;

		.icon {
			margin-right: -5px;

			/deep/ svg {
				$s: 16px;
				width: $s;
				height: $s;
			}
		}
	}

	.options {
		box-shadow: 0 0 5px 3px transparentize(#000, 0.97);
		background-color: $white1;
		border: 1px solid #E2E2E2;
		border-radius: 2px;
		max-height: 250px;
		font-size: 0.8em;
		overflow-y: auto;
		width: 100%;
		z-index: 1;

		position: absolute;
		top: calc(100% + 0.5em);
		left: 0;

		display: flex;
		flex-direction: column;

		.option {
			padding: 0.5em 1em;

			&.selected {
				background-color: #ededed;
			}
		}
	}

	input {
		cursor: pointer;
		user-select: none;
		position: absolute;
		appearance: none;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
	}
}
</style>
